import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-57fb179c"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "email",
  class: "email-label"
}, " Email ", -1))
const _hoisted_2 = {
  key: 0,
  class: "email-error-message"
}

import { debounce } from 'lodash';
import { onMounted, ref, watch } from 'vue';

interface EmailInputProps {
  initialEmail: string | null;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'EmailInput',
  props: {
    initialEmail: null
  },
  emits: ['onEmailChanged'],
  setup(__props: any, { emit }) {

const props = __props as {
  initialEmail: string | null;
};




const email = ref(props.initialEmail);
const emailError = ref(false);
const firstPass = ref(true);

onMounted(() => {
  if (firstPass.value && email.value) {
    processInput();
    firstPass.value = false;
    return;
  }

  if (firstPass.value) {
    firstPass.value = false;
    return;
  }

  processInput();
  firstPass.value = false;
});

watch(email, () => {
  emailError.value = false;
  processInput();
});

const processInput = debounce(async () => {
  emailError.value = false;

  const re = /\S+@\S+\.\S+/;
  if (re.test(email.value || '')) {
    emailError.value = false;
    emit('onEmailChanged', email.value);
    return;
  }

  emailError.value = true;
  emit('onEmailChanged', null);
}, 600);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _withDirectives(_createElementVNode("input", {
      onFocusout: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(processInput) && _unref(processInput)(...args))),
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((email).value = $event)),
      class: _normalizeClass(['email-input', emailError.value ? 'email-input-error' : '']),
      name: "email",
      type: "email",
      placeholder: "example@manifold.xyz"
    }, null, 34), [
      [_vModelText, email.value]
    ]),
    (emailError.value)
      ? (_openBlock(), _createElementBlock("p", _hoisted_2, " A valid email is required "))
      : _createCommentVNode("", true)
  ]))
}
}

})